import * as React from "react";
import { observer } from "mobx-react";
import { Button } from "./../Button";
import { Strings } from "../../Stores/StringsStore";

@observer
export class HandButton extends Button {

	render() {
		return <Button {...this.props} title={this.props.title ? this.props.title : Strings.reader.handButtonTooltip}>
			<i>
				<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
					<path d="M13,32h8a7,7,0,0,0,7-7V9a2,2,0,0,0-4,0v6.81a10.17,10.17,0,0,0-1-.6V4a2,2,0,0,0-4,0V14c-0.33,0-.66,0-1,0H17.95V2A2,2,0,0,0,14,2V14.75a10.4,10.4,0,0,0-1,.46V5A2,2,0,0,0,9,5V19.1a8.42,8.42,0,0,0-.53,1.16L6.12,16.43a2,2,0,0,0-2.75-.66l-0.71.43A2,2,0,0,0,2,19s4.41,8.51,6.62,10.77A10.72,10.72,0,0,0,13,32Z" />
				</svg>
			</i>
		</Button>;
	}
}
